import React from 'react';
import { useI18n } from '@monorepo/i18n';
import { EnumCell } from '@monorepo/ui-kit';
import { enumToSelectOptions } from '@monorepo/helpers';
import { PRODUCT_TYPES_DICTIONARY } from '../../constants';

type TProps = {
  value: string | number;
  defaultValue: string;
};

const ProductTypeEnum: Component<TProps> = ({ value, defaultValue }) => {
  const { t } = useI18n();
  return (
    <EnumCell
      dictionary={
        enumToSelectOptions(PRODUCT_TYPES_DICTIONARY, false, (item) =>
          t(`productTypes.${item}`)
        ) as any
      }
      value={value}
      defaultValue={defaultValue}
    />
  );
};

export default ProductTypeEnum;
